'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        restrict: 'A',
        template: require('../../../../../../../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter'
        },
        controller: ['$scope', '$uibModal', 'StatusService', 'SupportToolService', 'Notification', '$utils', 'ModalService',
            function ($scope, $modal, StatusService, SupportToolService, Notification, $utils, ModalService) {

                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.getStatusDisplayName = StatusService.getDisplayName;

                init();

                // region Functions

                function init() {
                    $scope.loading = true;

                    if (!$scope.selectedItem) {
                        $scope.selectedItem = {};
                    }

                    $scope.columns = [{
                        name: "Код",
                        data: "id"
                    }, {
                        name: "Наименование",
                        data: "name"
                    }, {
                        name: "Статус",
                        data: "status",
                        type: "status"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    // тулбокс таблицы
                    $scope.toolbox = {
                        // кнопки на панели управления
                        buttons: {
                            // создание
                            create: {
                                show: () => true,
                                click: () => SupportToolService.create().result.then(function (data) {
                                    SupportToolService.api.create(null, {"form": data}, (data) => {
                                        $scope.selectedItem = data._embedded;
                                        $scope.refresh();
                                    });
                                }),
                                disabled: () => false,
                            },
                            // редактирование
                            edit: {
                                show: () => true,
                                click: (item) => SupportToolService.edit(item).result.then(function (data) {
                                    SupportToolService.api.update({supportToolId: data.id}, {"form": data}, (data) => {
                                        $scope.selectedItem = data._embedded;
                                        $scope.refresh();
                                    });
                                }),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            // активация
                            enable: {
                                show: () => isSelected() && (getSelected().status == 'DELETED'),
                                click: (item) => SupportToolService.api.enable({supportToolId: item.id}, null, (data) => {
                                    $scope.selectedItem = data._embedded;
                                    $scope.refresh();
                                    Notification.success({
                                        message: 'Инструмент поддержки восстановлен!',
                                    });
                                }),
                                disabled: () => !isSelected() || getSelected().status == 'ENABLED',
                            },
                            // блокирование
                            disable: {
                                show: () => false,
                                click: (item) => {
                                },
                                disabled: () => true,
                            },
                            // логическое удаление
                            delete: {
                                show: () => false,
                                click: (item) => SupportToolService.api.delete({supportToolId: item.id}, null, (data) => $scope.refresh()),
                                disabled: () => !isSelected() || getSelected().status == 'DELETED',
                            },
                            // удаление
                            remove: {
                                show: () => isSelected() && (getSelected().status == 'ENABLED'),
                                click: (item) => ModalService.danger({
                                    message: "Запись будет удалена без возможности восстановления! Вы действительно желаете удалить данную запись?",
                                    apply: "Да",
                                    cancel: "Нет"
                                }).result.then(() => SupportToolService.api.remove({supportToolId: item.id}, null, (data) => {
                                        $scope.refresh();
                                        Notification.success({
                                            message: 'Инструмент поддержки удален!',
                                        });
                                    },
                                    (error) => {
                                        Notification.warning({
                                            title: "Внимание!",
                                            message: 'Данную запись удалить нельзя,<br />т.к. на нее ссылаются записи других таблиц.<br />Она будет помечена как "удаленная".',
                                        });
                                        SupportToolService.api.delete({supportToolId: item.id}, null, (data) => {
                                            $scope.refresh();
                                            Notification.success({
                                                message: 'Инструмент поддержки помечен как "удаленный"!',
                                            });
                                        });
                                    }
                                )),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            // обновление таблицы
                            refresh: {
                                show: () => true,
                                click: $scope.refresh,
                                disabled: () => false,
                            }
                        }
                    };

                    // получение данных
                    refresh();
                }

                /**
                 * Получение всех записей
                 * @returns {*}
                 */
                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбрал ли элемент!
                 * @param item проверяемый элемент
                 * @returns bool
                 */
                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                /**
                 * Выбрать элемент
                 * @param item выбираемый элемент
                 */
                function select(item) {
                    if (!$scope.isSelect(item)) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                /**
                 * Двойное нажатие на запись в таблице
                 * @param item данные записи
                 */
                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok();
                            break;
                    }
                }

                /**
                 * Получение фильтров
                 * @returns {Array}
                 */
                function getFilters() {
                    let filters = [];
                    if (Array.isArray($scope.filters)) {
                        filters = filters.concat($scope.filters);
                    }
                    return filters;
                }

                /**
                 * Получение поиска
                 * @returns {Array}
                 */
                function getSearchs() {
                    let searchs = [];
                    if ($scope.isSearch)
                        if ($scope.searching.filter != null && !($scope.searching.filter.length < 1))
                            searchs.push("'name':'" + $scope.searching.filter + "'");
                    return searchs;
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    return angular.equals(i1, i2);
                }

                /**
                 * Получить выбранный элемент
                 * @returns {{}|*}
                 */
                function getSelected() {
                    return $scope.selectedItem;
                }

                /**
                 * Обновить данные таблицы
                 */
                function refresh() {
                    $scope.loading = true;
                    SupportToolService.api.getAll({
                        filters: getFilters(),
                        searchs: getSearchs(),
                        sorts: ['name:ASC'],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size
                    }, function (data) {
                        $scope.items = data._embedded;
                        if (isSelected()) {
                            if ($scope.items.every(i => i.id != getSelected().id)) {
                                $scope.selectedItem = {};
                            } else {
                                angular.copy($scope.items.find(i => i.id == getSelected().id), $scope.selectedItem);
                            }
                        }
                        if ($scope.pagination.isPaging) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }
                        $scope.loading = false;
                    });
                }

                // endregion

                // region Watchers

                $scope.$watch('filters', function () {
                    $scope.refresh();
                });

                // endregion

            }]
    };
}
